import { Box, Tooltip } from "@mui/material";
import React from "react";

import { InfoOutlineIcon } from "assets/icons";
import { Typography } from "new-components/typography/Typography";

interface HeaderProps {
  title: string;
  description?: string;
}

export function Header(props: HeaderProps) {
  const { title, description } = props;

  return (
    <Tooltip title={description} disableHoverListener={!description}>
      <Box display="flex" alignItems="center" gap="4px" height="50px">
        {description && <InfoOutlineIcon color="#000000" />}
        <Typography variant="subtitle" fontWeight="medium" noWrap>
          {title}
        </Typography>
      </Box>
    </Tooltip>
  );
}
